var aerobilet_overlay_new = (function() {
	
	var overlay = null;

	return {
		show : function() {
			if (overlay == null) {
				overlay = $("#loading-flight").dialog({
					modal : true,
					autoOpen : false,
					resizable : false,
					draggable : false,
					width: 700,
					dialogClass : 'no-close'
				});
			}
			
			$(".ui-dialog-titlebar").hide();
			$("#filter_modal_loader,.ui-dialog").removeClass("ui-widget-content");
			
			overlay.dialog("open");
		},
		hide : function() {
			if (overlay != null) {
				$(".ui-dialog-titlebar").show();
				$("#filter_modal_loader,.ui-dialog").addClass("ui-widget-content");
				overlay.dialog("close");
			}
		}
	};
})();

function openFlightLoaderBox() {
	$("#loading-flight").show();
	aerobilet_overlay_new.show();
}

function closeFlightLoaderBox() {
	aerobilet_overlay_new.hide();
}